import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.6rem 4rem;

  @media (max-width: 600px) {
    padding: 1.6rem 0.8rem;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;

  > button {
    margin-left: 1.6rem;
  }

  > a {
    display: flex;
    align-self: stretch;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    background: #ef3535de;
    color: #fff;
    border-radius: 8px;
    margin-left: 1.6rem;
    padding: 0 2.4rem;
    font-size: 1.4rem;
    transition: background 0.2s;
    text-align: center;

    &:hover {
      filter: brightness(0.9);
    }
  }
`;

export const SearchInput = styled.input`
  border: none;
  border: 1px solid #c1c1c1;
  border-radius: 0.8rem;
  height: 4.8rem;
  padding: 0 0.8rem;
  color: #5d4e4f;
  font-size: 1.2rem;
  flex-grow: 1;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 2.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 1rem;

  background: #f5f6fa;
  border-radius: 8px;
  padding: 1.4rem 2rem;
  margin-top: 1rem;

  span {
    color: #5d4e4f;
    font-size: 1.4rem;
  }

  @media (max-width: 600px) {
    grid-template-columns: 0.7fr 2fr 0.5fr;

    span:not(:nth-child(1)):not(:nth-child(2)):not(:last-child) {
      display: none;
    }
  }
`;

export const TableBody = styled.div`
  margin: 1rem 0;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 2.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 1rem;

  background: #fff;
  border-radius: 8px;
  padding: 2.4rem 2rem;
  margin-bottom: 1rem;

  span {
    color: #000;
    font-size: 1.4rem;
    text-transform: uppercase;
    /* Truncate */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:first-of-type {
      color: #c4c4c4;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 0.7fr 2fr 0.5fr;

    span:not(:nth-child(1)):not(:nth-child(2)):not(:last-child) {
      display: none;
    }
  }
`;

export const EmptyContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;
  border-radius: 8px;
  padding: 2.4rem 2rem;
  margin-bottom: 1rem;

  color: #222;
  font-size: 1.4rem;
`;

export const IconsContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg {
    cursor: pointer;
    transition: opacity 200ms;

    &:hover {
      opacity: 0.6;
    }
  }

  @media (max-width: 600px) {
    svg + svg {
      margin-left: 0.8rem;
    }
  }
`;
